define('plugin/gallery/view/GalleryModuleIndexView',['require','lib/view/BaseCompositeView','plugin/gallery/view/GalleryModuleItemView','lib/view/UnwrapBehavior'],function (require) {

    var Parent = require('lib/view/BaseCompositeView');
    var GalleryModuleItemView = require('plugin/gallery/view/GalleryModuleItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Gallery composite view (images container)
     *
     * @class GalleryIndexView
     */
    return Parent.extend({

        template: '#gallery_module_list_view',
        childView: GalleryModuleItemView,
        childViewContainer: '#sb_gallery_module_list_container',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
        collectionEvents: {
            sync: 'render'
        },

        _moduleId: 'gallery',

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('module', 'shown', {
                'module': 'gallery'
            });
        }

    });

});
